import * as React from 'react';
import {FormComponentProps} from "antd/lib/form";
import {Form} from 'antd';
import locales from "../../locales";
import SubmitCancelFormItem from "../../common/form-items/SubmitCancelFormItem";
import ClientContactsFormItem from "../../common/contact/ClientContactsFormItem";

interface SendChecklistFormProps extends FormComponentProps {
    disabled: boolean;
    accepted: boolean;
    clientId: number;
    initialContactIds: number[];
    onFormCancel: () => void;
    onFormSubmit: (contactIds: number[]) => void;
}

const FIELD_CONTACTS = 'contacts';

class SendChecklistForm extends React.Component<SendChecklistFormProps, {}> {

    public render(): React.ReactNode {
        const {disabled, clientId, initialContactIds, children, form, accepted} = this.props;

        return (
            <>
                <Form>
                    <ClientContactsFormItem
                        form={form}
                        fieldId={FIELD_CONTACTS}
                        required={true}
                        disabled={disabled}
                        label={locales.checklist_recipients}
                        clientId={clientId}
                        initialContactIds={initialContactIds}
                    />

                </Form>
                {children}
                {!accepted &&
                    <SubmitCancelFormItem
                        disabled={disabled}
                        submitLabel={locales.checklist_send}
                        onSubmit={this.onFormSubmit}
                        onCancel={this.onFormCancel}
                    />
                }
            </>
        );
    }

    private onFormSubmit = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onFormSubmit(values[FIELD_CONTACTS]);
            }
        });
    };

    private onFormCancel = () => {
        this.props.form.resetFields();
        this.props.onFormCancel();
    };
}

export default Form.create<SendChecklistFormProps>()(SendChecklistForm);


// WEBPACK FOOTER //
// ./src/checklist/send/SendChecklistForm.tsx